import React from "react";
import ScrollAnimation from "react-animate-on-scroll";
import Label from "./Label";
import { setting } from "../Config/Config";
import { Carousel } from "antd";
import JSONData from "../data/data.json";
import { useState } from "react";
import { useEffect } from "react";
export const Header = (props) => {
  const [carouselData, setCarouselData] = useState([]);
  const getCarouselData = () => {
    setCarouselData(JSONData.Carousel);
  };
  useEffect(() => {
    getCarouselData();
  }, [carouselData]);
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div
              id="carousel"
              className="row"
              style={{
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Carousel
                autoplay
                dots={false}
                style={{
                  marginTop: "150",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {carouselData.map((item) => {
                  return (
                    <div>
                      <h1
                        style={{
                          fontFamily: setting.font,
                          color: setting.orange,
                          textTransform: "inherit",
                        }}
                      >
                        {item.title}
                        <span
                          style={{
                            fontSize: 30,
                            color: setting.blue,
                          }}
                        >
                          {item.subTitle}
                        </span>
                      </h1>
                      <p style={{ fontFamily: "monospace" }}>
                        {item.desc ? item.desc : "Loading"}
                      </p>
                    </div>
                  );
                })}
              </Carousel>
              <div
                className="col-md-8 col-md-offset-2 intro-text"
                style={{ marginBottom: -100, marginTop: -150 }}
              >
                <a
                  href="#features"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Learn More
                </a>
                <Label />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
